import { Component } from '@angular/core';
import { prefixReport } from 'src/app/onelog/common/config/url-prefix';

@Component({
  selector: 'app-list-report',
  templateUrl: './list-report.component.html',
  styleUrls: ['./list-report.component.css'],
})
export class ListReportComponent {
  prefixReport: string = prefixReport;
}
